import apiClient from "../services/apiClient"
import { setAccessToken } from "../services/apiClient"

export const handleLogout = async (): Promise<void> => {
  try {
    await apiClient.post("/auth/logout", undefined, { withCredentials: true })
  } catch {
    // proceed with local logout even if the server call fails
  }
  setAccessToken(null)
  window.location.href = "/login"
}

export const skipNull = (value: any): any => {
  if (value === null || value === undefined) return ""
  return value
}

export const skipNullWithDash = (value: any): any => {
  if (value === null || value === undefined) return "-"
  return value
}
